import React from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { isFeatureEnabled } from "reduxSlices/featuresSlice"
import { HELP_FEATURE } from "utils/featuresHelpers"
import { openInNewTab } from "utils/routeHelpers"
import withReduxProvider from "shared/withReduxProvider"
import CustomIconButton from "./CustomIconButton"
import Tooltip, { TOP_RIGHT } from "../Tooltip"

const openHelpDocs = () => openInNewTab("https://performancehealth.helpdocsite.com/");

const NeedHelpButton = ({ className = "" }) => {
  const helpFeatureEnabled = useSelector(isFeatureEnabled(HELP_FEATURE))

  if (!helpFeatureEnabled) return null

  return (
    <aside className={className} aria-label="need help">
      <Tooltip text="Password: Training" position={TOP_RIGHT}>
        <div className="pt-1">
          <CustomIconButton
            background="white"
            className="tertiary-button"
            icon="need-help"
            text="Need Help?"
            onClick={openHelpDocs}
          />
        </div>
      </Tooltip>
    </aside>
  )
}

NeedHelpButton.propTypes = {
  className: types.string,
}

export default withReduxProvider(NeedHelpButton)
